// const HAS_TOUCH = window.matchMedia('(any-pointer: course').matches;
// const HAS_MOUSE = window.matchMedia('(any-pointer: fine').matches;

export function supportsTouchInput () {
  return ('TouchEvent' in window);
  // return HAS_TOUCH;
}

export function supportsMouseInput () {
  return ('MouseEvent' in window);
  // return HAS_MOUSE;
}
